import presenceReportHours from '../personas/presenceReportHours'

const TYPE_LABELS = {
    correct: 'Aanwezig',
    absent: 'Afwezig',
    correction: 'Aanpassing',
}

/**
 * Zet aanwezigheidsrapporten om naar leesbare exportrijen.
 *
 * De uren komen uit `presenceReportHours`, dezelfde helper als het scherm: bij
 * 'Afwezig' 0, een gecorrigeerde begin- of eindtijd gaat voor de geroosterde,
 * en een dienst over middernacht telt door. Deze export had daar een eigen
 * kopie van — de vierde van een som die al drie keer uiteenliep — die
 * '25:00' als 25 uur las. Een csv gaat naar een gemeente, dus hij hoort
 * hetzelfde te zeggen als het scherm. Zie docs/inbox.md #294.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {Array<object>} reports - Documenten uit PersonaPresenceReports
 * @param {Array<{ID: string, Name: string}>} personas - Om het ID naar een naam te vertalen
 * @returns {Array<Record<string, any>>} Rijen voor de CSV
 */
const buildPresenceExportRows = (reports, personas) => {
    const nameById = new Map((personas || []).map((p) => [p.ID, p.Name]))

    return (reports || []).map((report) => {
        // Twee decimalen is genoeg voor een bestand; het scherm toont er één.
        const present = Math.round(presenceReportHours(report).hours * 100) / 100
        const scheduled = Number(report.Schedule) || 0

        return {
            Deelnemer: nameById.get(report.PersonaID) || 'Onbekend',
            Datum: report.DateKey || report.Date || '',
            Soort: TYPE_LABELS[report.Type] || report.Type || '',
            'Geroosterd van': report.Start || '',
            'Geroosterd tot': report.End || '',
            'Gecorrigeerd van': report.CorrectedStart || '',
            'Gecorrigeerd tot': report.CorrectedEnd || '',
            'Geroosterde uren': scheduled,
            'Aanwezige uren': present,
            Verschil: Math.round((present - scheduled) * 100) / 100,
            Reden: report.Reason || '',
        }
    })
}

export const PRESENCE_EXPORT_HEADER = [
    'Deelnemer',
    'Datum',
    'Soort',
    'Geroosterd van',
    'Geroosterd tot',
    'Gecorrigeerd van',
    'Gecorrigeerd tot',
    'Geroosterde uren',
    'Aanwezige uren',
    'Verschil',
    'Reden',
]

export default buildPresenceExportRows
